/* Project Import will be here */
import { post, IRequest } from "./index";
import { ISearchProductParams, IBannerDetailsParams } from "models/homeModels";
/* Project Import will be here */

export const getBannerApi = () => {
  const request: IRequest = { subUrl: `/Product/Banner` };
  return post(request);
};

export const getBannerViewApi = (data: IBannerDetailsParams) => {
  const request: IRequest = { subUrl: `/Product/BannerView`, data };
  return post(request);
};

export const getCartCountApi = () => {
  const request: IRequest = { subUrl: `/SalesOrder/CartCount` };
  return post(request);
};

export const getSearchProductsApi = (data: ISearchProductParams) => {
  const request: IRequest = { subUrl: `/Product/SearchProduct`, data };
  return post(request);
};

export const orderSummaryApi = (data) => {
  const request: IRequest = { subUrl: `/SalesOrder/OrderSummary`, data };
  return post(request);
};

/* Search by product API details */
export const searchByBarcodeApi = (data: ISearchProductParams) => {
  const request: IRequest = { subUrl: `/Product/SearchByBarcode`, data };
  return post(request);
};